var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center",class:_vm.wrapperClass},[_c('div',{staticClass:"spinner-border",class:_vm.spinnerClass,style:(_vm.cusotmStyles),attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }